function round(value: number, decimals: number): number {
	return Number.parseFloat((Math.round(value * 100) / 100).toFixed(decimals))
}

export const MathUtils = {
	round,
}
